import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from '@/i18n';
import globalPlugs from './global.plugs'

require('@/assets/css/animate.css')

Vue.config.productionTip = false;

Vue.use(globalPlugs)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
